import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
interface PricingGridProps {
  selectedPack: number;
  setSelectedPack: (pack: number) => void;
  packLinks: string[];
}
export function PricingGrid({
  selectedPack,
  setSelectedPack,
  packLinks
}: PricingGridProps) {
  return <div data-id="element-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-4" data-id="element-5">
        {/* Pack 0: Pack Completo */}
        <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer backdrop-blur-sm ${selectedPack === 0 ? 'bg-[#0d1530]/90 border-2 border-[#06b6d4] shadow-[0_0_20px_rgba(6,182,212,0.4)]' : 'bg-[#0d1530]/70 border-2 border-[#06b6d4]/30 shadow-[0_0_8px_rgba(6,182,212,0.1)] hover:border-[#06b6d4]/50'}`} data-id="element-6">
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#06b6d4] bg-[#06b6d4]' : 'border-gray-500'}`} data-id="element-7">
            {selectedPack === 0 && <CheckIcon className="w-2 h-2 md:w-2.5 md:h-2.5 text-black font-bold" data-id="element-8" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-9">📦</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-10">
            KIT COMPLETO MARKETING Y EMPRENDIMIENTO LISTO
          </h3>
          <p className="text-[10px] md:text-xs text-gray-400 mb-1.5 font-medium" data-id="element-11">
            6 Tomos + 4 Bonus + Acceso inmediato
          </p>
          <div className="flex items-baseline gap-1" data-id="element-12">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-13">
              $19.990
            </span>
          </div>
          <span className="text-gray-500 text-[10px] line-through font-bold" data-id="element-14">
            $39.990
          </span>
        </button>

        {/* Pack 1: Pack Premium */}
        <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-xl p-2 md:p-3 transition-all duration-200 cursor-pointer backdrop-blur-sm ${selectedPack === 1 ? 'bg-[#0d1530]/90 border-2 border-[#06b6d4] shadow-[0_0_20px_rgba(6,182,212,0.4)]' : 'bg-[#0d1530]/70 border-2 border-[#06b6d4]/30 shadow-[0_0_8px_rgba(6,182,212,0.1)] hover:border-[#06b6d4]/50'}`} data-id="element-15">
          <span className="absolute -top-2 left-1/2 -translate-x-1/2 bg-[#06b6d4] text-black text-[8px] md:text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap shadow-[0_0_10px_rgba(6,182,212,0.4)]" data-id="element-16">
            ⭐ Recomendado
          </span>
          <div className={`absolute top-2 right-2 w-3 h-3 md:w-4 md:h-4 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#06b6d4] bg-[#06b6d4]' : 'border-gray-500'}`} data-id="element-17">
            {selectedPack === 1 && <CheckIcon className="w-2 h-2 md:w-2.5 md:h-2.5 text-black font-bold" data-id="element-18" />}
          </div>
          <div className="text-lg mb-0.5" data-id="element-19">🚀</div>
          <h3 className="text-xs md:text-sm font-black text-white mb-0.5 pr-4 leading-tight" data-id="element-20">
            PACK PREMIUM
          </h3>
          <p className="text-[10px] md:text-xs text-[#22d3ee] mb-1.5 font-bold" data-id="element-21">
            KIT COMPLETO + SISTEMA AVANZADO DE EMPRENDIMIENTOS
          </p>
          <ul className="space-y-0.5 mb-1.5" data-id="element-22">
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-23">
              <CheckIcon className="w-2.5 h-2.5 text-[#06b6d4] flex-shrink-0 mt-0.5" data-id="element-24" />
              Creación de negocios reales
            </li>
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-25">
              <CheckIcon className="w-2.5 h-2.5 text-[#06b6d4] flex-shrink-0 mt-0.5" data-id="element-26" />
              Estrategias de marketing profundas
            </li>
            <li className="flex items-start gap-1 text-gray-300 text-[9px] md:text-[11px] leading-tight font-medium" data-id="element-27">
              <CheckIcon className="w-2.5 h-2.5 text-[#06b6d4] flex-shrink-0 mt-0.5" data-id="element-28" />
              Proyectos avanzados y de alto nivel
            </li>
          </ul>
          <div className="flex items-baseline gap-1" data-id="element-29">
            <span className="text-lg md:text-xl font-black text-white" data-id="element-30">
              $27.990
            </span>
          </div>
          <span className="text-gray-500 text-[10px] line-through font-bold" data-id="element-31">
            $49.990
          </span>
        </button>
      </div>

      {/* CTA Button */}
      <div className="text-center mb-2 md:mb-3" data-id="element-32">
        <a href={packLinks[selectedPack]} className="cta-pulse inline-flex items-center justify-center gap-1.5 w-full md:w-auto bg-[#06b6d4] hover:bg-[#0891b2] text-black font-black text-base md:text-lg py-2.5 px-6 md:py-3 md:px-10 rounded-xl transition-all duration-200 uppercase" data-id="element-33">
          👉 QUIERO MI KIT COMPLETO →
        </a>
        <p className="text-gray-400 text-[10px] md:text-xs font-bold mt-1.5 flex items-center justify-center gap-1 uppercase tracking-wider" data-id="element-34">
          <LockIcon className="w-3 h-3 text-[#06b6d4]" data-id="element-35" /> PAGO SEGURO · ACCESO
          INMEDIATO EN TU CORREO
        </p>
      </div>
    </div>;
}